(() => {
  const init = () => document.querySelectorAll('[data-mobile-quick-buy]:not([data-ready])').forEach(bar => {
    const section = document.getElementById(bar.dataset.productSection);
    const original = section?.querySelector('[data-add-to-cart]');
    const form = original?.closest('form');
    if (!form || !original) return;
    bar.dataset.ready = 'true';
    document.body.append(bar);
    const button = bar.querySelector('[data-quick-buy-button]');
    const price = bar.querySelector('[data-quick-buy-price]');
    const sourcePrice = section.querySelector('[data-product-price]');
    const wrapper = original.closest('[data-form-wrapper]');
    const mobile = matchMedia('(max-width:767px)');
    const controller = new AbortController();
    const signal = controller.signal;
    let pending = false;
    let frame = 0;
    const visible = node => {
      if (!node) return false;
      const rect = node.getBoundingClientRect();
      const style = getComputedStyle(node);
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && style.visibility !== 'hidden' && style.display !== 'none' && style.opacity !== '0';
    };
    const blocked = () => document.documentElement.hasAttribute('data-scroll-locked') || [...document.querySelectorAll('dialog[open],.pswp--open,.mfp-wrap,#smile-ui-container,#carthike-chat-container')].some(visible) || /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '');
    const state = () => {
      const id = form.querySelector('[name="id"]');
      const unavailable = !id?.value || wrapper?.classList.contains('variant--unavailabe');
      const sold = wrapper?.classList.contains('variant--soldout');
      const busy = pending || original.classList.contains('is-loading') || original.getAttribute('aria-busy') === 'true';
      return {unavailable,sold,busy,disabled:original.disabled || original.getAttribute('aria-disabled') === 'true'};
    };
    const sync = () => {
      frame = 0;
      const s = state();
      const label = s.unavailable ? bar.dataset.chooseLabel : s.sold ? bar.dataset.soldLabel : bar.dataset.addLabel;
      if (button.textContent !== label) button.textContent = label;
      button.disabled = Boolean(s.sold || s.busy || (!s.unavailable && s.disabled));
      button.setAttribute('aria-busy',String(s.busy));
      const value = s.unavailable ? '' : sourcePrice?.textContent.trim() || '';
      if (price.textContent !== value) price.textContent = value;
      const rect = original.getBoundingClientRect();
      const show = mobile.matches && rect.width > 0 && rect.bottom <= 0 && !blocked();
      bar.hidden = !show;
      document.body.classList.toggle('quick-buy-visible',show);
      document.body.classList.toggle('quick-buy-ready',mobile.matches);
      if (show) document.body.style.setProperty('--quick-buy-height',`${bar.offsetHeight}px`);
    };
    const schedule = () => {if (!frame) frame = requestAnimationFrame(sync);};
    const goToOptions = () => {
      const target = form.querySelector('select:not([hidden]),input:not([type="hidden"]),[data-option-position]') || original;
      target.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
      target.focus({preventScroll:true});
    };
    button.addEventListener('click',() => {
      const s = state();
      if (s.busy || s.sold || s.disabled) return;
      if (s.unavailable) {goToOptions(); return;}
      if (!form.checkValidity()) {goToOptions(); form.reportValidity(); return;}
      pending = true;
      sync();
      original.click();
      setTimeout(() => {pending = false; schedule();},1200);
    },{signal});
    const observer = new MutationObserver(schedule);
    observer.observe(original,{attributes:true,childList:true,subtree:true,characterData:true});
    if (sourcePrice) observer.observe(sourcePrice,{childList:true,subtree:true,characterData:true});
    if (wrapper) observer.observe(wrapper,{attributes:true,attributeFilter:['class']});
    observer.observe(document.documentElement,{attributes:true,attributeFilter:['data-scroll-locked','class']});
    ['scroll','resize'].forEach(event => window.addEventListener(event,schedule,{passive:true,signal}));
    ['change','input','focusin','focusout','theme:variant:change','theme:cart:open','theme:cart:close','theme:cart:added'].forEach(event => document.addEventListener(event,schedule,{signal}));
    document.addEventListener('click',schedule,{signal});
    mobile.addEventListener('change',schedule,{signal});
    window.visualViewport?.addEventListener('resize',schedule,{signal});
    document.addEventListener('shopify:section:unload',event => {
      if (!event.target.contains(section)) return;
      controller.abort(); observer.disconnect(); cancelAnimationFrame(frame); bar.remove();
      document.body.classList.remove('quick-buy-visible','quick-buy-ready');
    },{signal});
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load',init);
})();
